import {
  IChecklistItem,
  ChecklistItemStatus,
  getChecklistItemDate,
  getLatestDocTimestamp,
  getStatusByBankerComments,
} from "./checklist-item"
import { getMappedDocChecklistStatus } from "./loan-funding-phase"
import { StatusData } from "./status-data"

export const getBankerComments = (itemLabel: string, project: StatusData) => {
  switch (itemLabel) {
    case 'Signed Contract':
      return project.contractNotes
    case 'Loan Documents Sent':
      return project.loanDocumentsSentNotes
    case 'Loan Documents Signed':
      return project.loanDocumentsSignedNotes
    case 'Initial Bank Review Completed':
      return project.initialBankReviewNotes
    case 'Home Ownership Verification Completed':
      return project.homeOwnershipVerificationNotes
    case 'Final Bank Review':
      return project.bankFinalReviewNotes
    default:
      return null
  }
}

export const getLoanAppChecklistItemStatus = (item: IChecklistItem, project: StatusData) => {
  const itemDate = getChecklistItemDate(item, project)
 
  switch (item.label) {
    case 'Referral Sent':
      return itemDate ? ChecklistItemStatus.Completed : ''

    case 'Customer Prequalification Completed':
      if (project.createdDate && project.isPrequalified !== 'yes') return ChecklistItemStatus.NeedsAction
      if (project.isPrequalified === 'yes') return ChecklistItemStatus.Completed
      return ''

    case 'Signed Contract':
      const statusFromBankerComment = getStatusByBankerComments(project, item.dataField)
      if (statusFromBankerComment) return statusFromBankerComment

      const docStatus = getMappedDocChecklistStatus(project.installerDocs, item.label)
      if (docStatus) return docStatus

      if (project.isPrequalified === 'yes' && !itemDate) return ChecklistItemStatus.NeedsAction
      return ''

    case 'Application Submitted':
      if (itemDate) return ChecklistItemStatus.Completed
      // Check if previous step is completed (signed contract)
      const uploadedContractDate = getLatestDocTimestamp(project.uploads, 'Signed Contract')
      if (uploadedContractDate && !itemDate) return ChecklistItemStatus.NeedsAction
      return ''

    case 'Loan Documents Sent': {
      const statusFromBankerComment = getStatusByBankerComments(project, 'loanDocumentsSentNotes')
      if (statusFromBankerComment) return statusFromBankerComment

      if (itemDate) return ChecklistItemStatus.Completed
      if (project.applicationReceived && !itemDate) return ChecklistItemStatus.NeedsAction
      return ''
    }

    case 'Loan Documents Signed': {
      const statusFromBankerComment = getStatusByBankerComments(project, 'loanDocumentsSignedNotes')
      if (statusFromBankerComment) return statusFromBankerComment

      if (itemDate) return ChecklistItemStatus.Completed
      if (project.loanDocsIssuedDate && !itemDate) return ChecklistItemStatus.NeedsAction
      return ''
    }

    case 'Initial Bank Review Completed': {
      const statusFromBankerComment = getStatusByBankerComments(project, 'initialBankReviewNotes')
      if (statusFromBankerComment) return statusFromBankerComment

      if (project.loanDocsSignedDate && !itemDate) return ChecklistItemStatus.InProgress
      if (itemDate) return ChecklistItemStatus.Completed
      return ''
    }

    case 'Home Ownership Verification Completed': {
      const statusFromBankerComment = getStatusByBankerComments(project, 'homeOwnershipVerificationNotes')
      if (statusFromBankerComment) return statusFromBankerComment

      if (project.loanDocsSignedDate && !itemDate) return ChecklistItemStatus.InProgress
      if (itemDate) return ChecklistItemStatus.Completed
      return ''
    }

    case 'Final Bank Review': {
      const statusFromBankerComment = getStatusByBankerComments(project, 'bankFinalReviewNotes')
      if (statusFromBankerComment) return statusFromBankerComment

      if (project.docPrepQueueDate && project.propertyAppraiserReviewed && !itemDate)
        return ChecklistItemStatus.InProgress
      if (itemDate) return ChecklistItemStatus.Completed
      return ''
    }

    case 'NTP Issued':
      if (project.pendingBookingDate && !itemDate) return ChecklistItemStatus.InProgress
      if (itemDate) return ChecklistItemStatus.Completed
      return ''
    default:
      return ''
  }
}
